import { SELECT_SINGLE_ELEMENT } from "../../actions";
import ItemTypes from "../../constants/ItemTypes";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_SINGLE_ELEMENT:
      // Select single Text element
      if (action.payload.itemType === ItemTypes.TEXT) {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };
            if (layer.layer_id === action.payload.layerId) {
              layer.text_elements = layer.text_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    return {
                      ...element,
                      is_selected: action.payload.value,
                    };
                  } else {
                    return {
                      ...element,
                      is_selected: false,
                      is_key_element: false,
                    };
                  }
                },
              );
              // Deselect all image elements of this layer
              layer.image_elements = layer.image_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                  is_key_element: false,
                };
              });
            } else {
              // Deselect all text elements of other layers
              layer.text_elements = layer.text_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                  is_key_element: false,
                };
              });
              // Deselect all image elements of other layers
              layer.image_elements = layer.image_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                  is_key_element: false,
                };
              });
            }
            return layer;
          }),
        };
      } else if (action.payload.itemType === ItemTypes.IMAGE) {
        // Select single Image element

        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };
            if (layer.layer_id === action.payload.layerId) {
              layer.image_elements = layer.image_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    return {
                      ...element,
                      is_selected: action.payload.value,
                    };
                  } else {
                    return {
                      ...element,
                      is_selected: false,
                      is_key_element: false,
                    };
                  }
                },
              );
              // Deselect all text elements of this layer
              layer.text_elements = layer.text_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                  is_key_element: false,
                };
              });
            } else {
              // Deselect all image elements of other layers
              layer.image_elements = layer.image_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                  is_key_element: false,
                };
              });
              // Deselect all text elements of other layers
              layer.text_elements = layer.text_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                  is_key_element: false,
                };
              });
            }
            return layer;
          }),
        };
      } else {
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            const layer = { ...old_layer };
            if (layer.allow_image || layer.allow_text) {
              layer.text_elements = layer.text_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                };
              });
              layer.image_elements = layer.image_elements.map((element) => {
                return {
                  ...element,
                  is_selected: false,
                };
              });
            }
            return layer;
          }),
        };
      }

    default:
      return state;
  }
}
